// extracted by mini-css-extract-plugin
export var displayNone = "_p6-6";
export var imgContainer = "_p6-2";
export var overflowHidden = "_p6-3";
export var productInfoCardButtonContainer = "_p6-5";
export var productTitleText = "_p6-4";
export var rightArrow = "_p6-1";
export var rightArrowContainer = "_p6-0";